
import { appName } from '@/env';
import { mainStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  public email = '';

  public password = '';

  public appName = appName;

  public loading = false;
  backgroundKey = 0;
  public backgroundImage = '';
  public backgroundImagePhenom = '';
  public showPassword = true;

  hidePassword = true;
  redirectUri: string | null = null;

  get url() {
    return window.location.hostname;
  }

  public get sendPassword() {
    return mainStore.sendPassword;
  }

  public get loginError() {
    return mainStore.logInError;
  }

  public get loginErrorMessage() {
    return mainStore.loginErrorMessage;
  }

  public async forgotPassword() {
    this.showPassword = false;
  }

  public redirectToLogin() {
    mainStore.setSendPassword(false);
    this.showPassword = true;
  }

  public async doPasswordRecovery() {
    mainStore.recoverPassword({ email: this.email });
  }

  public async recoverPassword() {}

  focusEmail() {
    const emailField: any = this.$refs.emailField;
    if (emailField) {
      emailField.focus();
    }
  }

  async focusPassword() {
    if (!this.password) {
      const passwordField: any = this.$refs.passwordField;
      if (passwordField) {
        passwordField.focus();
      }
    } else {
      await this.submit();
    }
  }

  async mounted() {
    this.updateBackgroundImage();
    this.updateBackgroundImagePhenom();
    this.$watch(() => this.$vuetify.breakpoint.name, this.updateBackgroundImage);
    this.$watch(() => this.$vuetify.breakpoint.name, this.updateBackgroundImagePhenom);

    // Parse params
    const token = this.$router.currentRoute.query.token as string;
    this.redirectUri = this.$router.currentRoute.query.redirect_uri as string;

    if (token) {
      await mainStore.verifyEmail({ token: token });
    }
    this.focusEmail();
  }

  public async submit() {
    this.loading = true;
    const email = this.email;
    const password = this.password;
    //@ts-ignore
    const gCaptcha: any = grecaptcha;
    gCaptcha.ready(async () => {
      gCaptcha
        .execute('6Lc0K_IiAAAAAG9xyLxBf4LAChLzAyrZR4BtjbJr', {
          action: 'submit',
        })
        .then(async (token) => {
          await mainStore.logIn({
            username: email.toLowerCase(),
            password: password,
            gToken: token,
            redirectUri: this.redirectUri,
          });
          this.loading = false;
        });
    });
  }

  updateBackgroundImage() {
    let newBackground = '';

    if (this.$vuetify.breakpoint.lgAndUp) {
      newBackground =
        "https://mail.knnidiomas.com.br/knn-master/login/KnnClubDesktop2.png";
    } else if (this.$vuetify.breakpoint.md) {
      newBackground =
        "https://mail.knnidiomas.com.br/knn-master/login/knnClubTB.png";
    } else {
      newBackground =
        "https://mail.knnidiomas.com.br/knn-master/login/knnClubMobile.png";
    }

    if (this.backgroundImage !== newBackground) {
      this.backgroundImage = newBackground;
      this.backgroundKey++;
    }
  }

  updateBackgroundImagePhenom() {
    let newBackground = '';

    if (this.$vuetify.breakpoint.lgAndUp) {
      newBackground = 'https://mail.phenomidiomas.com.br/phenom-master/login/bgPhenom.png';
    } else if (this.$vuetify.breakpoint.md) {
      newBackground = 'https://mail.phenomidiomas.com.br/phenom-master/login/bgPhenomTablet.png';
    } else {
      newBackground = 'https://mail.phenomidiomas.com.br/phenom-master/login/bgPhenomMobile02.png';
    }

    if (this.backgroundImagePhenom !== newBackground) {
      this.backgroundImagePhenom = newBackground;
      this.backgroundKey++;
    }
  }
}
